import { useMemo, useReducer } from 'react'
import Fuse from 'fuse.js'

const increment = (x: number) => x + 1
export function useForceUpdate() {
  return useReducer(increment, 0)[1]
}

export function useFuse<T extends Record<string, any>>({
  items,
  keys,
  query,
  limit,
  threshold,
}: {
  items: T[]
  keys: (keyof T)[]
  query: string
  limit?: number
  threshold?: number
}) {
  const fuse = useMemo(() => {
    return new Fuse(items, {
      keys: keys as string[],
      findAllMatches: true,
      ignoreLocation: true,
      includeScore: true,
      threshold: threshold ?? 0.3,
      getFn(obj, paths) {
        const path = Array.isArray(paths) ? paths[0] : paths
        return (obj[path as keyof T] as string)?.replaceAll(' ', '')
      },
    })
  }, [items])

  return useMemo(
    () =>
      query
        ? fuse
            .search(query.replaceAll(' ', ''), limit ? { limit } : undefined)
            .map(({ item }) => item)
        : items,
    [query, fuse, items],
  )
}
